module.exports = __webpack_public_path__ + "img/12.b5498067.jpg";